module.exports = {
      id: "v-plus-logo-usage",
      viewBox: "0 0 165.404 72.698",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#v-plus-logo",
      toString: function () {
        return this.url;
      }
    }